var HTMLUtil = require('utilities/html');

module.exports = function (el, binding) {
	if (binding.value) {
		const firstInvoked = new Date().getTime();

		const focusElem = () => {
			// if element isn't in body yet, then try again in 15ms
			if (!el || !HTMLUtil.isDescendant(el, document.body) || !HTMLUtil.isVisible(el) || $(el).css('visibility') === 'hidden') {
				// only retry for 1 second
				if (new Date().getTime() - firstInvoked < 1000) {
					setTimeout(focusElem, 15);
				}
				return;
			}

			if (!$(el).is(':focus')) {
				$(el).focus();

				const valLength = $(el).val().length;
				el.setSelectionRange(valLength * 2, valLength * 2);
			}
		};

		setTimeout(focusElem, 5);
	}
};
